import { useMutation } from "@tanstack/react-query";
import { login, LoginCredentials, AuthResult } from "../../lib/services/authService";

/**
 * useLogin: React Query mutation hook for login operation.
 * Usage: const { mutate: login, isLoading, error, data } = useLogin();
 */
export function useLogin() {
  return useMutation<AuthResult, Error, LoginCredentials>({
    mutationKey: ["auth", "login"],
    mutationFn: login,
  });
}
